import Eaccount from "../components/Account/Eaccount";
import Nav from "../components/Nav/nav";
import Whatsapp from "../Whatsapp/whatsapp";

const Account = () => {
  return (
    <div>
      <Nav />
      <Eaccount />
      <Whatsapp />
    </div>
  );
};

export default Account;
